import Header from "../../components/feature/Header";
import Breadcrumbs from "../../components/feature/Breadcrumbs";
import Footer from "../../components/feature/Footer";
import WhatsAppFloating from "../../components/feature/WhatsAppFloating";
import CookieBanner from "../../components/feature/CookieBanner";
import { Link } from "react-router-dom";
import SEO from "../../components/feature/SEO";

const cities = [
  { name: "Málaga", slug: "malaga", desc: "Reparación de persianas en Málaga capital y barrios (Centro, El Palo, Teatinos)" },
  { name: "Marbella", slug: "marbella", desc: "Persianas, toldos y mosquiteras en Marbella, Puerto Banús y Nueva Andalucía" },
  { name: "Fuengirola", slug: "fuengirola", desc: "Servicio en Fuengirola, Los Pacos y Torreblanca" },
  { name: "Torremolinos", slug: "torremolinos", desc: "Persianas en Torremolinos, La Carihuela y Playamar" },
  { name: "Benalmádena", slug: "benalmadena", desc: "Benalmádena Costa, Pueblo y Arroyo de la Miel" },
  { name: "Mijas", slug: "mijas", desc: "Mijas Pueblo, Mijas Costa, La Cala y Calahonda" },
  { name: "Estepona", slug: "estepona", desc: "Estepona centro, puerto y urbanizaciones" },
  { name: "Vélez-Málaga", slug: "velez-malaga", desc: "Costa oriental, Torre del Mar" },
  { name: "Rincón de la Victoria", slug: "rincon-de-la-victoria", desc: "Costa oriental, La Cala del Moral" },
  { name: "Benahavís", slug: "benahavis", desc: "Suiza Andaluza, urbanizaciones golf premium" },
  { name: "San Pedro de Alcántara", slug: "san-pedro-de-alcantara", desc: "Costa Oeste, centro y Guadalmina" },
];

const comarcas = [
  {
    name: "Axarquía",
    slug: "axarquia",
    desc: "Comarca este de Málaga. Frigiliana, Cómpeta, Comares y 12 pueblos blancos del interior.",
  },
  {
    name: "Valle del Guadalhorce",
    slug: "valle-del-guadalhorce",
    desc: "Comarca agrícola al norte de Málaga. Almogía, Pizarra, Ardales y pueblos del valle.",
  },
  {
    name: "Serranía de Ronda",
    slug: "serrania-de-ronda",
    desc: "Comarca montañosa del oeste. Júzcar, Gaucín, Casares y pueblos blancos del Genal.",
  },
];

export default function Zonas() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Zonas" }]}
      />
      <Header />
      <Breadcrumbs />
      <main>
        <section className="py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h1 className="font-heading font-extrabold text-4xl md:text-5xl text-text-primary mb-4">
                Zonas donde trabajamos
              </h1>
              <p className="font-body text-lg text-text-secondary max-w-2xl mx-auto">
                Instalamos y reparamos persianas, toldos y mosquiteras en toda la Costa del Sol y comarcas del interior. Desde Málaga capital hasta Ronda.
              </p>
            </div>

            {/* Ciudades principales */}
            <h2 className="font-heading font-bold text-2xl text-text-primary mb-6">
              Ciudades principales
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
              {cities.map((city) => (
                <Link
                  key={city.slug}
                  to={`/zonas/${city.slug}`}
                  className="block border border-border rounded-2xl p-6 bg-white hover:border-primary hover:shadow-sm transition-all group"
                >
                  <h3 className="font-heading font-bold text-xl text-text-primary mb-1 group-hover:text-primary transition-colors">
                    {city.name}
                  </h3>
                  <p className="font-body text-sm text-text-secondary">{city.desc}</p>
                </Link>
              ))}
            </div>

            {/* Comarcas del interior */}
            <h2 className="font-heading font-bold text-2xl text-text-primary mb-4">
              Comarcas del interior
            </h2>
            <p className="font-body text-base text-text-secondary leading-relaxed mb-6 max-w-3xl">
              También cubrimos las comarcas rurales de Málaga, agrupando visitas para optimizar costes de desplazamiento.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {comarcas.map((comarca) => (
                <Link
                  key={comarca.slug}
                  to={`/zonas/${comarca.slug}`}
                  className="block border border-border rounded-2xl p-6 bg-white hover:border-primary hover:shadow-sm transition-all group"
                >
                  <h3 className="font-heading font-bold text-xl text-text-primary mb-2 group-hover:text-primary transition-colors">
                    {comarca.name}
                  </h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{comarca.desc}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}